import { render, staticRenderFns } from "./task_edit.vue?vue&type=template&id=2eb6030b&"
import script from "./task_edit.vue?vue&type=script&lang=js&"
export * from "./task_edit.vue?vue&type=script&lang=js&"
import style0 from "./task_edit.vue?vue&type=style&index=0&scope=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports